import React from "react";
import { ChevronDown } from "react-feather";
import { useTheme } from "../theme/ThemeContext";
import { SORT_OPTIONS } from "../utils/sort";

const SortSelect = ({ value, onChange }) => {
  const { tokens } = useTheme();

  return (
    <div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Sort by"
        style={{
          appearance: "none",
          padding: "9px 32px 9px 14px",
          borderRadius: 10,
          border: `1px solid ${tokens.surfaceBorder}`,
          backgroundColor: tokens.surface,
          color: tokens.textPrimary,
          fontSize: 13.5,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        {SORT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown
        size={14}
        color={tokens.textMuted}
        style={{ position: "absolute", right: 10, pointerEvents: "none" }}
      />
    </div>
  );
};

export default SortSelect;
